import { Skeleton } from '@/components/Skeleton';

import styles from './ModuleCard.module.scss';

const ModuleCardSkeleton = () => (
  <div className={styles.root}>
    <div className={styles.preview}>
      <Skeleton containerClassName={styles.heading} height={17} inline width={100} />
    </div>
    <div className={styles.content}>
      <div className={styles.pricing}>
        <Skeleton height={11} maxWidth={56} />
        <Skeleton height={24} maxWidth={126} />
        <Skeleton height={11} maxWidth={178} />
      </div>
      <div className={styles.availableCategories}>
        <Skeleton height={15} maxWidth={227} />
        <Skeleton height={15} maxWidth={183} />
      </div>
    </div>
  </div>
);

export default ModuleCardSkeleton;
